// @ts-nocheck
export const localeCodes =  [
  "en",
  "pt",
  "fr"
]
export const localeLoaders = {
  en: [
    {
      key: "locale_en_46ts_000d4a76",
      load: () => import("#nuxt-i18n/000d4a76" /* webpackChunkName: "locale_en_46ts_000d4a76" */),
      cache: false
    }
  ],
  pt: [
    {
      key: "locale_pt_46ts_197157e8",
      load: () => import("#nuxt-i18n/197157e8" /* webpackChunkName: "locale_pt_46ts_197157e8" */),
      cache: false
    }
  ],
  fr: [
    {
      key: "locale_fr_46ts_f307d5b8",
      load: () => import("#nuxt-i18n/f307d5b8" /* webpackChunkName: "locale_fr_46ts_f307d5b8" */),
      cache: false
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    emoji: "🇺🇸",
    icon: "flag:um-1x1",
    name: "English",
    code: "en",
    language: "en-GB",
    translationLocale: "en-GB",
    country: "United Kingdom"
  },
  {
    emoji: "🇵🇹",
    icon: "flag:br-1x1",
    name: "Português",
    code: "pt",
    language: "pt-PT",
    translationLocale: "pt-PT",
    country: "Portugal"
  },
  {
    emoji: "🇫🇷",
    icon: "flag:fr-1x1",
    name: "Français",
    code: "fr",
    language: "fr-FR",
    translationLocale: "fr-FR",
    country: "Francia"
  }
]
/** client **/

/** client-end **/